module.exports =
  {

    // Search scripts
    removePlots:
    {

        // Method-wide scripts
        _init: function ()
        {
            
          

          function getQueryVariable(variable)
          {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i=0;i<vars.length;i++) {
                        var pair = vars[i].split("=");
                        if(pair[0] == variable){return pair[1];}
                }
                return(false);
          }
          APPLICATION._APPLICATION.processLinks('#plots', 'Administration', 'plots')
          var append = "";
          if (getQueryVariable('reload')==1)
          {
            
            
            append = "?reload=1&company_id=" + getQueryVariable('company_id') + '&status=' + getQueryVariable('status') + '&development_name=' + getQueryVariable('development_name') + '&plot_number=' + getQueryVariable('plot_number');
          }
          APPLICATION._APPLICATION.load($('#plots'), APPLICATION._PATH_PREFIX + 'administration/plots' + append, 'Administration', 'plots')
        }
    },
    // Submissions scripts
    plots:
    {

      // Method-wide scripts
      _init: function ()
      {
        
        // Get the development
        var development = $('#development_id')
        // list of id's to be submitted to modal.
        //$ids =[];
        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // If no brand or company
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'plot/dropdown-developments/' + company_id + '?coins_plot_id=' + development.val(), 'Plot', 'dropdownDevelopment')
          }

        }
        ).addClass('js-ignore').trigger('change')
        
        
        
        
      },
      attach_edit: function(){
        $('.delete-button').on('click',function(){
          
          var ids = [];
        
          
          $.each($("input[name='plot_id']:checked"), function(){  
              ids.push($(this).val());
          });
          $("#plots").data('ids',ids.join(","));
          company_id = $("#company_id").val();
          status = $('#status').val();
          ids = $("#plots").data('ids');
          //$("#plot_ids").(ids);
          //console.log('Modal : ' + $('#plot_ids').val());
          APPLICATION._APPLICATION.customModal('/administration/edit/?plot_ids='+ids + '&company_id=' + company_id + '&status=' + status,'administration','edit');
          
        }) 
      },
      attach_restore: function(){
        $('.delete-button').on('click',function(){
          
          var ids = [];
        
          
          $.each($("input[name='plot_id']:checked"), function(){  
              ids.push($(this).val());
          });
          $("#plots").data('ids',ids.join(","));
          company_id = $("#company_id").val();
          status = $('#status').val();
          ids = $("#plots").data('ids');
          //$("#plot_ids").(ids);
          //console.log('Modal : ' + $('#plot_ids').val());
          APPLICATION._APPLICATION.customModal('/administration/restore/?plot_ids='+ids + '&company_id=' + company_id + '&status=' + status,'administration','restore');
          
        })
      }
    },
    edit:
    {
        _init: function() {
          
          
          
        },
        conditional_reason: function() {
          $('#reason_id').not('js-ignore').change(function(e){
            if ($('#reason_id').val()== 6)
            {
              $('#reason-detail').not('js-ignore').removeClass('collapse')
            } else
            {
              if (!$('#reason-detail').hasClass('collapse'))
              $('#reason-detail').not('js-ignore').addClass('collapse')
            }
          })
        }

    },

    changeNotificationBanner:
    {
      _init: function()
      {
        if($('#open-modal').length){
          APPLICATION._APPLICATION.customModal('/administration/confirm-notification-banner','Administration','confirmNotificationBanner');
        }
      }
    },

    confirmNotificationBanner:
    {
      _init: function()
      {
        $('[name="confirmed"]')?.remove();

        $('#notification-modal-enabled').text($('#enabled').is(':checked') ? 'Enabled' : 'Disabled');
        $('#notification-modal-title').text($('#title').val());
        $('#notification-modal-message').text($('#message').val());

        $('#notification-banner-confirm').on('click', function(){
          $('#notification-banner-form').append('<input type="hidden" name="confirmed">')
          $('#notification-banner-form').trigger('submit');
        });
      }
    },
  }